import React from 'react';
import block from 'bem-cn';

import InputPhoto from 'components/InputPhoto/mobile';
import Button from 'components/Button';
import SVG from 'components/SVG';
import Input from 'components/Input';
import Select from 'components/Select/desktop';
import Switcher from 'components/Switcher';
import Spinner from 'components/Spinner/view/desktop';

import useCreatePromotions from 'features/bonusProgram/model/useCreatePromotions';
import settingsSVG from 'features/bonusProgram/data/img/settings.svg';
import imageSVG from 'features/bonusProgram/data/img/image.svg';
import { searchInItems } from 'features/bonusProgram/data';

import './CreatePromotions.scss';

const b = block('create-promotions');

const CreatePromotions = () => {
  const { values, handlers, locale, filters } = useCreatePromotions();

  return (
    <div className={b()}>
      <Spinner isLoading={values.actionProcessing} />
      <div className={b('content')}>
        <div className={b('settings')}>
          <div className={b('settings-header')}>
            <SVG className={b('icon')} svgProps={{ svg: settingsSVG }} alt="" />
            <div className={b('title')}>{locale.settings}</div>
          </div>
          <div className={b('block')}>
            <div className={b('block-row')}>
              <div className={b('block-row-title')}>{locale.active}</div>
              <div className={b('switch')}>
                <Switcher
                  isActive={values.state.active}
                  onSwitch={() => handlers.handleActiveChange(!values.state.active)}
                  color="dark"
                />
              </div>
            </div>
            <div className={b('block-row')}>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.title}</div>
                <div className={b('item-field')}>
                  <Input
                    value={values.state.title}
                    onChange={e => handlers.handleTitleChange(e.currentTarget.value)}
                    placeholder={locale.title}
                  />
                </div>
              </div>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.language}</div>
                <div className={b('item-field')}>
                  <Select
                    name="lang"
                    items={searchInItems.slice(1)}
                    activeItem={filters.lang}
                    onChange={handlers.handleSearchInChange}
                  />
                </div>
              </div>
            </div>
            <div className={b('block-row')}>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.url}</div>
                <div className={b('item-field')}>
                  <Input
                    value={values.state.url}
                    onChange={e => handlers.handleUrlChange(e.currentTarget.value)}
                    placeholder={locale.url}
                  />
                </div>
              </div>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.callToAction}</div>
                <div className={b('item-field')}>
                  <Input
                    value={values.state.callToAction}
                    onChange={e => handlers.handleCallToActionChange(e.currentTarget.value)}
                    placeholder={locale.callToAction}
                  />
                </div>
              </div>
            </div>
            <div className={b('block-row')}>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.shortDescription}</div>
                <div className={b('item-field')}>
                  <Input
                    value={values.state.shortDescription}
                    onChange={e => handlers.handleShortDescriptionChange(e.currentTarget.value)}
                    placeholder={locale.shortDescription}
                  />
                </div>
              </div>
            </div>
            <div className={b('block-row', { fullHeight: true })}>
              <div className={b('item')}>
                <div className={b('item-label')}>{locale.fullDescription}</div>

                <textarea
                  className={b('textarea')}
                  value={values.state.fullDescription}
                  onChange={e => handlers.handleFullDescriptionChange(e.currentTarget.value)}
                  placeholder={locale.noMore30}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={b('image')}>
          <div className={b('image-header')}>
            <SVG className={b('icon')} svgProps={{ svg: imageSVG }} alt="" />
            <div className={b('title')}>{locale.image}</div>
          </div>
          <div className={b('block')}>
            <div className={b('block-row-title')}>{locale.previewImage}</div>
            <div className={b('image-content')}>
              {values.promotionById?.urlMiniImage ? (
                <img
                  className={b('image-content-image')}
                  src={`https://ganamos.net/static//promotions/${values.promotionById?.urlMiniImage.split('/').pop()}`}
                  alt=""
                />
              ) : (
                <InputPhoto
                  currentImageData={values.state.bannerData}
                  onImageChange={handlers.handleBannerDataChange}
                  url={values.state.bannerUrl}
                  text={locale.chooseFile}
                  iconSize="75"
                  altLayout
                />
              )}
            </div>
            <div className={b('item-label', { gapBottom: true })}>
              <span>* </span> {locale.previewImageDescription}
            </div>

            <div className={b('block-row-title')}>{locale.promoBanner}</div>
            <div className={b('image-content')}>
              {values.promotionById?.urlImage ? (
                <img
                  className={b('image-content-image')}
                  src={`https://ganamos.net/static//promotions/${values.promotionById?.urlImage.split('/').pop()}`}
                  alt=""
                />
              ) : (
                <InputPhoto
                  currentImageData={values.state.imageData}
                  onImageChange={handlers.handleImageDataChange}
                  url={values.state.imageUrl}
                  text={locale.promoBanner}
                  iconSize="75"
                  altLayout
                />
              )}
            </div>
            <div className={b('item-label')}>
              <div className={b('item-label')}>
                <span>* </span>
                {locale.bannerDescription}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={b('actions')}>
        <Button
          text={locale.cancel}
          callBack={handlers.handleCancelClick}
          className={b('cancel')}
          color="transparent"
        />
        <Button
          disabled={(!values.state.imageData.image || !values.state.bannerData.image) && !values.promotionById?.id}
          text={locale.save}
          callBack={handlers.handleSaveClick}
          className={b('save')}
        />
      </div>
    </div>
  );
};

export default CreatePromotions;
